// Calendar-only list presets; these strings never affect document save values.
export function documentPeriod(year: number, month: number): { from: string; to: string } | undefined {
  if (!Number.isInteger(year) || year < 1900 || year > 2099 || !Number.isInteger(month) || month < 0 || month > 12) return undefined;
  if (month === 0) return { from: `${year}-01-01`, to: `${year}-12-31` };
  const prefix = `${year}-${String(month).padStart(2, '0')}`;
  return { from: `${prefix}-01`, to: `${prefix}-${new Date(Date.UTC(year, month, 0)).getUTCDate()}` };
}
